import { render } from "./BookView.vue?vue&type=template&id=76c94972&scoped=true"
import script from "./BookView.vue?vue&type=script&lang=js"
export * from "./BookView.vue?vue&type=script&lang=js"

import "./BookView.css?vue&type=style&index=0&id=76c94972&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76c94972"]])

export default __exports__